import format from 'date-fns/format';

export const CARD_COLORS = [
  '#4C7DFF',
  '#9C27B0',
  '#009688',
  '#FF9800',
  '#F44336',
  '#673AB7',
  '#3F51B5',
  '#607D8B',
  '#E91E63',
  '#00BCD4',
];

export const getCardColor = id => {
  return CARD_COLORS[Math.abs(id) % CARD_COLORS.length];
};

export const formatDate = dateObj => {
  if (!dateObj?.timestamp) {
    return '';
  }

  try {
    return format(
      new Date(dateObj.timestamp),
      'MMMM do, yyyy'
    );
  } catch {
    return '';
  }
};